import { LicenseType, User } from "@/schemas/User"

export function resolveUserLicenseType(user: null | User): LicenseType {
  if (user === null) return "NONE"
  if (user.license.isDemo) return "DEMO"
  return "FULL"
}
